// The questionnaire template for the staff screens: one query key for the
// link dialog and the editor, one mutation key for both writes so a page
// can ask "is a write in flight" once.

import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  fetchIntakeTemplate,
  resetIntakeTemplate,
  saveIntakeTemplate,
  type IntakeTemplatePut,
} from "../api/intake";

export const INTAKE_TEMPLATE_KEY = ["intake", "template"] as const;
export const INTAKE_TEMPLATE_WRITE = ["intake", "template", "write"] as const;

export function useIntakeTemplate(enabled = true) {
  return useQuery({
    queryKey: INTAKE_TEMPLATE_KEY,
    queryFn: fetchIntakeTemplate,
    enabled,
    staleTime: 60_000,
  });
}

export function useSaveIntakeTemplate() {
  const qc = useQueryClient();
  return useMutation({
    mutationKey: INTAKE_TEMPLATE_WRITE,
    mutationFn: (body: IntakeTemplatePut) => saveIntakeTemplate(body),
    onSuccess: (data) => qc.setQueryData(INTAKE_TEMPLATE_KEY, data),
  });
}

export function useResetIntakeTemplate() {
  const qc = useQueryClient();
  return useMutation({
    mutationKey: INTAKE_TEMPLATE_WRITE,
    mutationFn: resetIntakeTemplate,
    onSuccess: ({ removed: _removed, ...data }) => qc.setQueryData(INTAKE_TEMPLATE_KEY, data),
  });
}
